import { JANELA_COPY } from "./janela-bloco.constants";
import type { JanelaBlocoProps, JanelaBlocoViewModel } from "./types-janela-bloco";

export function useJanelaBloco({
  tipo,
  values,
  valorError,
  invalid,
  disabled,
  onChange,
  onValorBlur,
}: JanelaBlocoProps): JanelaBlocoViewModel {
  const { title, checkbox } = JANELA_COPY[tipo];
  const id = `papel-obra-${tipo}`;

  return {
    titulo: title,
    checkboxLabel: checkbox,
    ids: {
      bloco: `${id}-bloco`,
      marcado: `${id}-marcado`,
      linha: `${id}-linha`,
      valor: `${id}-valor`,
      valorError: `${id}-valor-error`,
      unidade: `${id}-unidade`,
      relacao: `${id}-relacao`,
      marco: `${id}-marco`,
    },
    labels: {
      valor: `${title}: quantidade`,
      unidade: `${title}: unidade`,
      relacao: `${title}: relação`,
      marco: `${title}: marco`,
    },
    values,
    valorError,
    valorInvalido: invalid || Boolean(valorError),
    camposInvalidos: invalid,
    disabled,
    marcar: (marcado) => onChange({ marcado }),
    // Só dígitos: o valor vira dias inteiros.
    digitarValor: (texto) => onChange({ valor: texto.replace(/\D/g, "") }),
    sairDoValor: onValorBlur,
    escolherUnidade: (unidade) => (unidade ? onChange({ unidade }) : undefined),
    escolherRelacao: (relacao) => (relacao ? onChange({ relacao }) : undefined),
    escolherMarco: (marco) => (marco ? onChange({ marco }) : undefined),
  };
}
